import Container from '@mui/material/Container';
import Drawer from '@mui/material/Drawer';
import { ReactNode } from 'react';

import * as desktopLayoutStyles from './DesktopLayout.styles';
import Menu from '../Menu';
// import NewOrderContainer from '../../../Orders/components/NewOrderContainer';
import { AppContextProvider } from '../../../../context/app/AppContext';

export interface DesktopLayoutProps {
  children?: ReactNode;
}

function DesktopLayout({ children }: DesktopLayoutProps) {
  const { classes } = desktopLayoutStyles.useLayoutStyles();
  return (
    <AppContextProvider isHub>
      {/* <NewOrderContainer /> */}
      <div className={classes.wrapper}>
        <Container className={classes.root} maxWidth="xl" disableGutters>
          <Drawer
            variant="permanent"
            // @ts-expect-error https://github.com/mui/material-ui/issues/27703
            PaperProps={{ component: 'nav' }}
            className={classes.drawer}
            classes={{
              paper: classes.drawer,
            }}
          >
            <Menu />
          </Drawer>
          <main className={classes.content}>{children}</main>
        </Container>
      </div>
    </AppContextProvider>
  );
}

export default DesktopLayout;
